import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';

export interface ApiEndpointDoc {
  method: string;
  path: string;
  service: string;
  auth: 'authenticated' | 'apiKey' | 'public';
  sourceFile: string;
  summary?: string;
  requestExample?: any;
  responseExample?: any;
}

export interface ApiDocsResponse {
  generatedAt: Date;
  serverUrl?: string;
  apiKey?: string;
  endpoints: ApiEndpointDoc[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiDocsService {

  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService) {}

  list() {
    return this.http.get<ApiDocsResponse>(this.connectionService.address + "/api-docs");
  }
}
